import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Sky } from 'three/addons/objects/Sky.js'
import { Timer } from 'three/addons/misc/Timer.js'
// import GUI from 'lil-gui'

/**
 * Base
 */
// Debug
// const gui = new GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Texture
 */

const textureLoader = new THREE.TextureLoader

//Texture - Floor

const floorAlphaTexture = textureLoader.load("./floor/alpha.jpg")

const floorARMTexture = textureLoader.load("./floor/mud/brown_mud_03_arm_1k.webp") 
const floorDiffuseTexture = textureLoader.load("./floor/mud/brown_mud_03_diff_1k.webp") 
const floorDisplacementTexture = textureLoader.load("./floor/mud/brown_mud_03_disp_1k.jpg") 
const floorNormalGLTexture = textureLoader.load("./floor/mud/brown_mud_03_nor_gl_1k.webp") 

floorDiffuseTexture.colorSpace = THREE.SRGBColorSpace

floorARMTexture.repeat.set(4, 4)
floorDiffuseTexture.repeat.set(4, 4)
floorDisplacementTexture.repeat.set(4, 4)
floorNormalGLTexture.repeat.set(4, 4)

floorARMTexture.wrapS = THREE.RepeatWrapping
floorDiffuseTexture.wrapS = THREE.RepeatWrapping
floorDisplacementTexture.wrapS = THREE.RepeatWrapping
floorNormalGLTexture.wrapS = THREE.RepeatWrapping

floorARMTexture.wrapT = THREE.RepeatWrapping
floorDiffuseTexture.wrapT = THREE.RepeatWrapping
floorDisplacementTexture.wrapT = THREE.RepeatWrapping
floorNormalGLTexture.wrapT = THREE.RepeatWrapping

//Textures - Wall

const wallARMTexture = textureLoader.load("./wall/broken_brick_wall_arm_1k.webp") 
const wallDiffuseTexture = textureLoader.load("./wall/broken_brick_wall_diff_1k.webp") 
const wallNormalGLTexture = textureLoader.load("./wall/broken_brick_wall_nor_gl_1k.webp") 

// wallARMTexture.repeat.set(8, 8)
// wallDiffuseTexture.repeat.set(8, 8)
// wallNormalGLTexture.repeat.set(8, 8)

wallARMTexture.wrapS = THREE.RepeatWrapping
wallDiffuseTexture.wrapS = THREE.RepeatWrapping
wallNormalGLTexture.wrapS = THREE.RepeatWrapping

wallARMTexture.wrapT = THREE.RepeatWrapping
wallDiffuseTexture.wrapT = THREE.RepeatWrapping
wallNormalGLTexture.wrapT = THREE.RepeatWrapping

wallDiffuseTexture.colorSpace = THREE.SRGBColorSpace

//Textures - Roof

const roofARMTexture = textureLoader.load("./roof/clay_roof_tiles_02_arm_1k.webp") 
const roofDiffuseTexture = textureLoader.load("./roof/clay_roof_tiles_02_diff_1k.webp") 
const roofNormalGLTexture = textureLoader.load("./roof/clay_roof_tiles_02_nor_gl_1k.webp") 

roofARMTexture.repeat.set(3, 1)
roofDiffuseTexture.repeat.set(3, 1)
roofNormalGLTexture.repeat.set(3, 1)

roofARMTexture.wrapS = THREE.RepeatWrapping
roofDiffuseTexture.wrapS = THREE.RepeatWrapping
roofNormalGLTexture.wrapS = THREE.RepeatWrapping

roofARMTexture.wrapT = THREE.RepeatWrapping
roofDiffuseTexture.wrapT = THREE.RepeatWrapping
roofNormalGLTexture.wrapT = THREE.RepeatWrapping

roofDiffuseTexture.colorSpace = THREE.SRGBColorSpace

// //Textures - Bushes

// const bushesARMTexture = textureLoader.load("./bushes/caerial_rocks_02_arm_1k.jpg") 
// const bushesDiffuseTexture = textureLoader.load("./bushes/aerial_rocks_02_diff_1k.jpg") 
// const bushesNormalGLTexture = textureLoader.load("./bushes/aerial_rocks_02_nor_gl_1k.jpg") 

// bushesARMTexture.repeat.set(8, 8)
// bushesDiffuseTexture.repeat.set(8, 8)
// bushesNormalGLTexture.repeat.set(8, 8)

// bushesARMTexture.wrapS = THREE.RepeatWrapping
// bushesDiffuseTexture.wrapS = THREE.RepeatWrapping
// bushesNormalGLTexture.wrapS = THREE.RepeatWrapping

// bushesARMTexture.wrapT = THREE.RepeatWrapping
// bushesDiffuseTexture.wrapT = THREE.RepeatWrapping
// bushesNormalGLTexture.wrapT = THREE.RepeatWrapping

// bushesDiffuseTexture.colorSpace = THREE.SRGBColorSpace


//Textures - Graves

const gravesARMTexture = textureLoader.load("./graves/plastered_stone_wall_arm_1k.webp") 
const gravesDiffuseTexture = textureLoader.load("./graves/plastered_stone_wall_diff_1k.webp") 
const gravesNormalGLTexture = textureLoader.load("./graves/plastered_stone_wall_nor_gl_1k.webp") 

gravesARMTexture.repeat.set(0.3, 0.4)
gravesDiffuseTexture.repeat.set(0.3, 0.4)
gravesNormalGLTexture.repeat.set(0.3, 0.4)

gravesARMTexture.wrapS = THREE.RepeatWrapping
gravesDiffuseTexture.wrapS = THREE.RepeatWrapping
gravesNormalGLTexture.wrapS = THREE.RepeatWrapping

gravesARMTexture.wrapT = THREE.RepeatWrapping
gravesDiffuseTexture.wrapT = THREE.RepeatWrapping
gravesNormalGLTexture.wrapT = THREE.RepeatWrapping

gravesDiffuseTexture.colorSpace = THREE.SRGBColorSpace

//Textures - Door
const doorColorTexture = textureLoader.load('./door/color.webp')
const doorAlphaTexture = textureLoader.load('./door/alpha.webp')
const doorAmbientOcclusionTexture = textureLoader.load('./door/ambientOcclusion.webp')
const doorHeightTexture = textureLoader.load('./door/height.webp')
const doorNormalTexture = textureLoader.load('./door/normal.webp')
const doorMetalnessTexture = textureLoader.load('./door/metalness.webp')
const doorRoughnessTexture = textureLoader.load('./door/roughness.webp')

doorColorTexture.colorSpace = THREE.SRGBColorSpace


/**
 * House
 */


//Floor
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(20, 20, 100, 100),
    new THREE.MeshStandardMaterial({
        alphaMap: floorAlphaTexture,
        transparent: true,
        map: floorDiffuseTexture,
        aoMap: floorARMTexture,
        roughnessMap: floorARMTexture,
        metalnessMap: floorARMTexture,
        normalMap: floorNormalGLTexture,
        displacementMap: floorDisplacementTexture,
        displacementScale: 0.3,
        displacementBias: - 0.2
    })
)
floor.rotation.x = -Math.PI * 0.5
scene.add(floor)

// gui.add(floor.material, 'displacementScale').min(0).max(1).step(0.001).name('floorDisplacementScale')
// gui.add(floor.material, 'displacementBias').min(-1).max(1).step(0.001).name('floorBias')

//Hoouse Container
const house = new THREE.Group()
scene.add(house)

//Walls
const walls = new THREE.Mesh(
    new THREE.BoxGeometry(4, 2.5, 4),
    new THREE.MeshStandardMaterial({
        map: wallDiffuseTexture,
        aoMap: wallARMTexture,
        roughnessMap: wallARMTexture,
        metalnessMap: wallARMTexture,
        normalMap: wallNormalGLTexture


    })
)
walls.position.y += 1.25

house.add(walls)

//Roof
const roof = new THREE.Mesh(
    new THREE.ConeGeometry(3.5, 1.5, 4),
    new THREE.MeshStandardMaterial({
        map: roofDiffuseTexture,
        aoMap: roofARMTexture,
        roughnessMap: roofARMTexture,
        metalnessMap: roofARMTexture,
        normalMap: roofNormalGLTexture
    })   
)
roof.position.y = 2.5 + 0.75
roof.rotation.y = Math.PI * 0.25

house.add(roof)

//Door
const door = new THREE.Mesh(
    new THREE.PlaneGeometry(2.2, 2.2, 100, 100),
    new THREE.MeshStandardMaterial({
        map: doorColorTexture,
        transparent: true,
        alphaMap: doorAlphaTexture,
        aoMap: doorAmbientOcclusionTexture,
        displacementMap: doorHeightTexture,
        displacementScale: 0.15,
        displacementBias: - 0.04,
        normalMap: doorNormalTexture,
        metalnessMap: doorMetalnessTexture,
        roughnessMap: doorRoughnessTexture
    })
)
door.position.y = 1
door.position.z = 2 + 0.01

house.add(door)

// //Bushes
// const bushGeometry = new THREE.SphereGeometry(1, 16, 16)
// const bushMaterial = new THREE.MeshStandardMaterial({
//         color: '#ccffcc',
//         map: bushesDiffuseTexture,
//         // aoMap: bushesARMTexture,
//         // roughnessMap: bushesARMTexture,
//         // metalnessMap: bushesARMTexture,
//         normalMap: bushesNormalGLTexture
// })

// const bush1 = new THREE.Mesh(bushGeometry, bushMaterial)
// bush1.scale.set(0.5, 0.5, 0.5)
// bush1.position.set(0.8, 0.2, 2.2)
// bush1.rotation.x = -0.75

// const bush2 = new THREE.Mesh(bushGeometry, bushMaterial)
// bush2.scale.set(0.25, 0.25, 0.25)
// bush2.position.set(1.4, 0.1, 2.1)
// bush2.rotation.x = -0.75

// const bush3 = new THREE.Mesh(bushGeometry, bushMaterial)
// bush3.scale.set(0.4, 0.4, 0.4)
// bush3.position.set(- 0.8, 0.1, 2.2)
// bush3.rotation.x = -0.75

// const bush4 = new THREE.Mesh(bushGeometry, bushMaterial)
// bush4.scale.set(0.15, 0.15, 0.15)
// bush4.position.set(- 1, 0.05, 2.6)
// bush4.rotation.x = -0.75

// house.add(bush1, bush2, bush3, bush4)

// Graves
const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2)
const graveMaterial = new THREE.MeshStandardMaterial({
        map: gravesDiffuseTexture,
        aoMap: gravesARMTexture,
        roughnessMap: gravesARMTexture,
        metalnessMap: gravesARMTexture,
        normalMap: gravesNormalGLTexture
})

const graves = new THREE.Group()
scene.add(graves)

for(let i = 0; i < 30; i++) {

    const angle = Math.random() * Math.PI * 2
    const radius = 3 + Math.random() * 5
    const x = Math.sin(angle) * radius
    const z = Math.cos(angle) * radius 

    //Mesh
    const grave = new THREE.Mesh(graveGeometry, graveMaterial)
    grave.position.x = x
    grave.position.y = Math.random() * 0.4
    grave.position.z = z
    grave.rotation.x = (Math.random() - 0.5) * 0.4
    grave.rotation.y = (Math.random() - 0.5) * 0.4
    grave.rotation.z = (Math.random() - 0.5) * 0.4


    // Add to graves group
    graves.add(grave)
}





/**
 * Lights
 */
// Ambient light
const ambientLight = new THREE.AmbientLight('#86cdff', 0.275)
scene.add(ambientLight)

// Directional light
const directionalLight = new THREE.DirectionalLight('#86cdff', 1)
directionalLight.position.set(3, 2, -8)
scene.add(directionalLight)

//Door Light
const doorLight = new THREE.PointLight('#ff7d46', 5)
doorLight.position.set(0, 2.2, 2.5)
house.add(doorLight)

/**
 * Ghosts
 */

const ghost1 = new THREE.PointLight('#8800ff', 6)
const ghost2 = new THREE.PointLight('#ff0088', 6)
const ghost3 = new THREE.PointLight('#ff0000', 6)
scene.add(ghost1, ghost2, ghost3)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 7
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Shadows
 */
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap

// Cast and Receive
directionalLight.castShadow = true
ghost1.castShadow = true
ghost2.castShadow = true
ghost3.castShadow = true

walls.castShadow = true
walls.receiveShadow = true
roof.castShadow = true
floor.receiveShadow = true

for (const grave of graves.children) {
    grave.castShadow = true
    grave.receiveShadow = true
}

// Mapping
directionalLight.shadow.mapSize.width = 256
directionalLight.shadow.mapSize.height = 256
directionalLight.shadow.camera.top = 8
directionalLight.shadow.camera.right = 8
directionalLight.shadow.camera.bottom = -8
directionalLight.shadow.camera.left = -8
directionalLight.shadow.camera.near = 1
directionalLight.shadow.camera.far = 20

ghost1.shadow.mapSize.width = 256
ghost1.shadow.mapSize.height = 256
ghost1.shadow.camera.far = 10

ghost2.shadow.mapSize.width = 256
ghost2.shadow.mapSize.height = 256
ghost2.shadow.camera.far = 10

ghost3.shadow.mapSize.width = 256
ghost3.shadow.mapSize.height = 256
ghost3.shadow.camera.far = 10

/**
 * Sky
 */

const sky = new Sky()
sky.scale.set(100, 100, 100)
scene.add(sky)

sky.material.uniforms['turbidity'].value = 10
sky.material.uniforms['rayleigh'].value = 3
sky.material.uniforms['mieCoefficient'].value = 0.1
sky.material.uniforms['mieDirectionalG'].value = 0.95
sky.material.uniforms['sunPosition'].value.set(0.3, -0.038, -0.95)

/**
 * Fog
 */
// scene.fog = new THREE.Fog('ff0000', 10, 13)
scene.fog = new THREE.FogExp2('#04343f', 0.1)

/**
 * Animate
 */
const timer = new Timer()

const tick = () =>
{
    // Timer
    timer.update()
    const elapsedTime = timer.getElapsed()

    //Ghosts
    const ghost1Angle = elapsedTime * 0.5
    ghost1.position.x = Math.cos(ghost1Angle) * 4
    ghost1.position.z = Math.cos(ghost1Angle) * 4
    ghost1.position.y = Math.sin(ghost1Angle) * Math.sin(ghost1Angle * 2.34) * Math.sin(ghost1Angle * 3.45)

    const ghost2Angle = - elapsedTime * 0.38
    ghost2.position.x = Math.cos(ghost2Angle) * 5
    ghost2.position.z = Math.sin(ghost2Angle) * 5
    ghost2.position.y = Math.sin(ghost2Angle) * Math.sin(ghost2Angle * 2.34) * Math.sin(ghost2Angle * 3.45)

    const ghost3Angle = elapsedTime * 0.23
    ghost3.position.x = Math.cos(ghost3Angle) * 6
    ghost3.position.z = Math.sin(ghost3Angle) * 6
    ghost3.position.y = Math.sin(ghost3Angle) * Math.sin(ghost3Angle * 2.34) * Math.sin(ghost3Angle * 3.45)

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()